<template>
  <div class="page-healthy" :style="{ height: pageHeight + 'px' }">
    <div class="healthy">
      <div class="option-box">
        <div class="option">
          楼
          <el-select v-model="tower" placeholder="请选择">
            <el-option
              v-for="item in towers"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          层
          <el-select v-model="floor" placeholder="请选择">
            <el-option
              v-for="item in floors"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          房
          <el-select v-model="room" placeholder="请选择">
            <el-option
              v-for="item in rooms"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button type="primary">筛选</el-button>
        </div>
        <div class="option">
          <el-button>昨天</el-button>
          <el-button>前天</el-button>
          <el-button>过去7天</el-button>
          <el-button>过去30天</el-button>
          <el-button @click="export2Excel">导出表格</el-button>
        </div>
      </div>

      <div class="sleep-list">
        <el-scrollbar style="height: 100%">
          <el-table :data="sleepList" border stripe style="width: 100%">
            <el-table-column prop="bed" label="床位" align="center" sortable>
            </el-table-column>
            <el-table-column
              prop="score"
              label="睡眠得分"
              align="center"
              sortable
            >
            </el-table-column>
            <el-table-column
              prop="sleepTime"
              label="睡眠时长"
              align="center"
              sortable
            >
            </el-table-column>
            <el-table-column
              prop="outBedTime"
              label="离床时长"
              align="center"
              sortable
            >
            </el-table-column>
            <el-table-column
              prop="outBedNum"
              label="夜间离床次数"
              align="center"
              sortable
            >
            </el-table-column>
            <el-table-column
              prop="moveNum"
              label="体动次数"
              align="center"
              sortable
            >
            </el-table-column>
            <el-table-column prop="breather" align="center" sortable>
              <template slot="header">
                呼吸紊乱指数(AHI)
                <el-tooltip content="呼吸紊乱指数说明" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="option" label="睡眠报告" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="showReport(scope.row)"
                  >查看 <i class="el-icon-view"></i
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
    </div>

    <!-- 查看报告弹窗 -->
    <el-dialog
      id="printTest"
      :title="sleepInfo.bed + '睡眠报告'"
      :visible.sync="isShowReport"
      width="50%"
      left
      top="0"
      destroy-on-close
    >
      <div class="date-btn">
        <el-button v-print="'#printTest'">昨天</el-button>
        <el-button>前天</el-button>
        <el-button>过去7天</el-button>
        <el-button>过去30天</el-button>
      </div>

      <!-- 睡眠得分 -->
      <div class="sleep-score">
        <!-- <div>
          <div>睡眠时长 <span>8</span>小时<span>29</span>分钟</div>
        </div> -->
        <el-progress
          type="circle"
          :percentage="46"
          :stroke-width="40"
          :width="400"
          :show-text="false"
          stroke-linecap="butt"
        >
        </el-progress>
        <!-- <div>
          <div><span>8</span>小时<span>29</span>分钟</div>
        </div> -->
        <div class="score-text">
          <div>睡眠得分</div>
          <div>92</div>
        </div>
      </div>

      <!-- 睡眠占比 -->
      <div class="sleep-chart-box">
        <div><i class="el-icon-moon-night"></i> 睡眠占比</div>
        <div class="sleep-chart" id="percent"></div>
      </div>

      <!-- 睡眠详情 -->
      <div class="sleep-chart-box">
        <div>
          <i class="el-icon-moon-night"></i> 睡眠详情(21:21入睡,05:51起床)
        </div>
        <div class="sleep-chart" id="sleep-info"></div>
      </div>

      <!-- 呼吸率 -->
      <div class="sleep-chart-box">
        <div><i class="el-icon-moon-night"></i> 呼吸率(次/分钟)</div>
        <div class="sleep-chart" id="breather"></div>
      </div>

      <!-- 心率 -->
      <div class="sleep-chart-box">
        <div><i class="el-icon-moon-night"></i> 心率(次/分钟)</div>
        <div class="sleep-chart" id="heart"></div>
      </div>

      <!-- 体动详情 -->
      <div class="sleep-chart-box">
        <div><i class="el-icon-moon-night"></i> 体动详情(次)</div>
        <div class="sleep-chart" id="sport-info"></div>
      </div>

      <!-- 睡眠呼吸情况 -->
      <div class="sleep-breather-box">
        <div><i class="el-icon-moon-night"></i> 睡眠呼吸情况</div>
        <el-table
          :data="sleepBreatherInfo"
          border
          :show-header="false"
          style="width: 100%; margin-top: 10px"
          :span-method="mergeCells"
        >
          <el-table-column prop="one" align="center"> </el-table-column>
          <el-table-column prop="two" align="center"> </el-table-column>
          <el-table-column prop="three" align="center"> </el-table-column>
          <el-table-column prop="four" align="center"> </el-table-column>
        </el-table>
      </div>

      <!-- 呼吸事件 -->
      <div class="sleep-chart-box">
        <div><i class="el-icon-moon-night"></i> 呼吸事件</div>
        <div class="sleep-chart" id="breather-event"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts/core";
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
} from "echarts/components";
import { PieChart, BarChart, LineChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BarChart,
  PieChart,
  LineChart,
  CanvasRenderer,
]);

export default {
  name: "Healthy",
  data() {
    return {
      pageHeight: 0,
      towers: [
        {
          label: "A楼",
          value: "A",
        },
        {
          label: "B楼",
          value: "B",
        },
        {
          label: "C楼",
          value: "C",
        },
        {
          label: "D楼",
          value: "D",
        },
        {
          label: "全部",
          value: "0",
        },
      ],
      tower: "0",
      floors: [
        {
          label: "1层",
          value: "1",
        },
        {
          label: "2层",
          value: "2",
        },
        {
          label: "3层",
          value: "3",
        },
        {
          label: "全部",
          value: "0",
        },
      ],
      floor: "0",
      rooms: [
        {
          label: "D5151",
          value: "5151",
        },
        {
          label: "D5152",
          value: "5152",
        },
        {
          label: "D5153",
          value: "5153",
        },
        {
          label: "全部",
          value: "0",
        },
      ],
      room: "0",
      sleepList: [
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
        {
          bed: "D楼5层D5151",
          score: 90,
          sleepTime: "8小时30分钟",
          outBedTime: "0小时0分钟",
          outBedNum: 0,
          moveNum: 0,
          breather: 0.36,
        },
      ],

      isShowReport: false,
      sleepInfo: {},

      sleepBreatherInfo: [
        {
          one: "呼吸暂停次数",
          two: "3次",
          three: "呼吸暂停总时长",
          four: "47秒",
        },
        {
          one: "占睡眠时间比例",
          two: "0.15%",
          three: "呼吸暂停平均时长",
          four: "15秒",
        },
        {
          one: "最长呼吸暂停发生于",
          two: "03点16分08秒",
          three: "最长呼吸暂停时长",
          four: "16秒",
        },
        {
          one: "低通气次数",
          two: "0次",
          three: "低通气总时长",
          four: "0秒",
        },
        {
          one: "呼吸暂停指数(AI)",
          two: "0.36",
          three: "低通气指数(HI)",
          four: "0",
        },
        {
          one: "呼吸紊乱指数(AHI)",
          two: "0.36",
        },
        {
          one: "建议",
          two: "多吃蔬果多运动，继续保持良好的生活习惯",
        },
      ],
    };
  },
  created() {
    this.initPageHeight()

    window.addEventListener("resize", this.initPageHeight);
  },
  mounted() {},
  computed: {},
  methods: {
    initPageHeight(){
      this.pageHeight = window.innerHeight - 60;
    },
    // 导出表格
    export2Excel() {
      require.ensure([], () => {
        const { export_json_to_excel } = require("./vendor/Export2Excel");
        const tHeader = [
          "床位",
          "睡眠得分",
          "睡眠时长",
          "离床时长",
          "夜间离床次数",
          "体动次数",
          "呼吸紊乱指数(AHI)",
        ];
        const filterVal = [
          "bed",
          "score",
          "sleepTime",
          "outBedTime",
          "outBedNum",
          "moveNum",
          "breather",
        ];
        const list = this.sleepList;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "列表excel");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 查看睡眠报告
    showReport(data) {
      this.sleepInfo = data;
      this.isShowReport = true;

      this.$nextTick(() => {
        this.sleepPercentPie();
        this.sleepInfoBar();
        this.breatherLine();
        this.heartLine();
        this.sportInfoBar();
        this.breatherEventBar();
      });
    },

    // 睡眠占比饼图
    sleepPercentPie() {
      var chartDom = document.getElementById("percent");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          // top: "5%",
          left: "right",
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["70%", "90%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 96, name: "浅睡(%)" },
              { value: 4, name: "深睡" },
              { value: 0, name: "清醒" },
              { value: 0, name: "离床" },
            ],
          },
        ],
      };

      option && myChart.setOption(option);
    },

    // 睡眠详情柱状图
    sleepInfoBar() {
      var chartDom = document.getElementById("sleep-info");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: "世界人口总量",
          subtext: "数据来自网络",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["2011年", "2012年"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          data: ["巴西", "印尼", "美国", "印度", "中国", "世界人口(万)"],
        },
        series: [
          {
            name: "2011年",
            type: "bar",
            data: [18203, 23489, 29034, 104970, 131744, 630230],
          },
          {
            name: "2012年",
            type: "bar",
            data: [19325, 23438, 31000, 121594, 134141, 681807],
          },
        ],
      };

      option && myChart.setOption(option);
    },

    // 呼吸率折线图
    breatherLine() {
      var chartDom = document.getElementById("breather");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 260],
            type: "line",
          },
        ],
      };

      option && myChart.setOption(option);
    },

    // 心率折线图
    heartLine() {
      var chartDom = document.getElementById("heart");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 260],
            type: "line",
          },
        ],
      };

      option && myChart.setOption(option);
    },

    // 体动详情柱状图
    sportInfoBar() {
      var chartDom = document.getElementById("sport-info");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130],
            type: "bar",
          },
        ],
      };

      option && myChart.setOption(option);
    },

    // 合并单元格
    mergeCells({ row, column, rowIndex, columnIndex }) {
      if (
        rowIndex == this.sleepBreatherInfo.length - 1 ||
        rowIndex == this.sleepBreatherInfo.length - 2
      ) {
        if (columnIndex === 1) {
          return [1, 3];
        } else if (columnIndex === 2 || columnIndex === 3) {
          return [0, 0];
        }
      }
    },

    // 呼吸事件柱状图
    breatherEventBar() {
      var chartDom = document.getElementById("breather-event");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: "世界人口总量",
          subtext: "数据来自网络",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["2011年", "2012年"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          data: ["巴西", "印尼", "美国", "印度", "中国", "世界人口(万)"],
        },
        series: [
          {
            name: "2011年",
            type: "bar",
            data: [18203, 23489, 29034, 104970, 131744, 630230],
          },
          {
            name: "2012年",
            type: "bar",
            data: [19325, 23438, 31000, 121594, 134141, 681807],
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
  watch: {},
  beforeDestroy() {
    window.removeEventListener("resize", this.initPageHeight);
  },
};
</script>

<style scoped lang='less'>
.page-healthy {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  padding: 20px 5% 0;
  box-sizing: border-box;

  .healthy {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 5px 5px 0 0;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .option-box {
      display: flex;
      justify-content: space-between;
    }

    .sleep-list {
      flex: 1;
      margin-top: 10px;
      overflow: hidden;
    }
  }

  .sleep-score {
    width: 100%;
    height: 200px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    position: relative;

    .score-text {
      width: 200px;
      position: absolute;
      left: 50%;
      margin-left: -100px;
      bottom: 0;
      text-align: center;

      div:first-child {
        font-size: 24px;
      }
      div:last-child {
        font-size: 60px;
        font-weight: bold;
        color: #409eff;
      }
    }
  }

  .sleep-chart-box {
    width: 100%;
    height: 400px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;

    .sleep-chart {
      width: 100%;
      flex: 1;
    }
  }

  .sleep-breather-box {
    width: 100%;
    margin-top: 20px;
  }
}
</style>
<style>
.el-select {
  margin: 0 10px;
}
.el-select-dropdown__wrap {
  margin-bottom: 0 !important;
}
.el-progress-circle {
  align-self: center;
  transform: rotate(-90deg);
}
@media print {
  body {
    zoom: 0.3;
  }
  .sleep-score {
    width: 100%;
    height: 200px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    position: relative;
  }
  .score-text {
    width: 200px;
    position: absolute;
    left: 50%;
    margin-left: -100px;
    bottom: 0;
    text-align: center;
  }
  .score-text div:first-child {
    font-size: 24px;
  }
  .score-text div:last-child {
    font-size: 60px;
    font-weight: bold;
    color: #409eff;
  }
  .el-progress-circle {
    align-self: center;
    transform: rotate(-90deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/healthy.vue